<template>
  <div>
    <a href="http://www.cerealcityscience.org"><img src="./../../assets/store-logo.png" width="200px"></a>
    <h1 class="brand">Cereal City Science - Organism Card Order Form</h1>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>
